/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationModel from './models/NotificationModel';
import { AppButton, AppList } from '../../index';
import AuthService from '../../logic/services/AuthService';
import NotificationListItem from './components/NotificationListItem';
import LPOverridable from '../../components/overrides/LPOverridable';
import { Trans } from 'react-i18next';
import Tick from '../../assets/Tick.svg';

class NotificationsPage extends Component<any, any> {
  list: any;

  constructor(props: any) {
    super(props);
    setTimeout(() => {
      AuthService.refreshAuth();
    }, 4000);
  }

  componentDidMount() {
    new NotificationModel().seenNotifications();
  }

  _renderNotificationItem(i: any) {
    return (
      <NotificationListItem
        notification={i}
        key={i.id}
        closeNotification={() => this.refreshNotifications()}
      />
    );
  }

  readAllNotifucations() {
    new NotificationModel().readAllNotifications();
    this.refreshNotifications();
  }

  refreshNotifications() {
    console.log('refresh list');
    if (this.list) {
      this.list._reset().then(() => {
        console.log('refresh list 2');

        this.list._refresh();
        AuthService.refreshAuth();
      });
    }
  }

  render() {
    // let unreadNotifications = null;

    // if (this.props.profile && this.props.profile.unreadNotifications) {
    //   unreadNotifications = (
    //     <div className="notificationNumber">
    //       <span>{this.props.profile.unreadNotifications}</span>
    //     </div>
    //   );
    // }

    return (
      <div className="container">
        <div style={{ paddingTop: 100 }}>
          <div
            className="profile-container"
            style={{ height: '70vh', overflow: 'auto', position: 'relative' }}
          >
            {this.props.profile.unreadNotifications !== 0 && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}
              >
                <AppButton
                  onClick={() => this.readAllNotifucations()}
                  customstyle={{ maxWidth: 150 }}
                  inverted
                >
                  <Trans>Read all</Trans>
                </AppButton>
              </div>
            )}
            <div className="row ">
              <div className="col-lg-12 notifications-col-12">
                <LPOverridable name="notificationsPage.page.header">
                  <div className="notifications-header">
                    <button type="button" className="select-all-button">
                      <span>
                        <Trans>Select All</Trans>
                      </span>
                    </button>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="dropdown notifications-dropdown">
                        <button
                          type="button"
                          className="dropdown-toggle notifications-dropdown-button"
                          data-toggle="dropdown"
                        >
                          <span>
                            <Trans>More</Trans>
                          </span>
                          {/* <i className="fa fa-caret-down"></i> */}
                        </button>
                        <ul className="dropdown-menu" id="moreDropdown">
                          <li>
                            <Trans>Archive</Trans>
                          </li>
                          <li>
                            <Trans>Mark as read</Trans>
                          </li>
                          <li>
                            <Trans>Mark as unread</Trans>
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown notifications-dropdown">
                        <button
                          type="button"
                          className="dropdown-toggle notifications-dropdown-button"
                          data-toggle="dropdown"
                        >
                          <span>
                            <Trans>Type</Trans>
                          </span>
                          {/* <i className="fa fa-caret-down"></i> */}
                        </button>
                        <ul className="dropdown-menu" id="moreDropdown">
                          {/* <span className="arrow-up"></span>
                    <span className="cover-arrow"></span> */}
                          <li>
                            <Trans>System message</Trans>{' '}
                            <img src={Tick} className="check-icon" alt="" />
                          </li>
                          <li>
                            <Trans>Promotion and offers</Trans>{' '}
                            <img src={Tick} className="check-icon" alt="" />
                          </li>
                          <li>
                            <Trans>Incoming transactions</Trans>{' '}
                            <img src={Tick} className="check-icon" alt="" />
                          </li>
                          <li>
                            <Trans>Outgoing transactions</Trans>{' '}
                            <img src={Tick} className="check-icon" alt="" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </LPOverridable>

                <div className="notifications-body">
                  <AppList
                    onInit={(list: any) => (this.list = list)}
                    model={NotificationModel}
                    renderWrapper={(items: React.ReactNode) => (
                      <ul style={{ padding: 0, marginBottom: 0 }}>{items}</ul>
                    )}
                    renderItem={(item: any) =>
                      this._renderNotificationItem(item)
                    }
                    renderNoItems={() => (
                      <div className="col-sm-12 well text-center">
                        <div style={{ margin: '20px' }} className="no-items">
                          <em>
                            <Trans>No new notifications</Trans>
                          </em>
                        </div>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: { auth: { profile: any } }) => {
  return {
    profile: state.auth.profile
  };
};

export default connect(mapStateToProps)(NotificationsPage);
